export default [
	{ label: 'Vegana', emission: 955, unit: 'persona/any' },
	{ label: 'Vegetariana', emission: 1053, unit: 'persona/any' },
	{ label: 'Pescatariana', emission: 1431, unit: 'persona/any' },
	{ label: 'Omnívora sense carn vermella', emission: 1234, unit: 'persona/any' },
	{ label: 'Omnívora', emission: 2282, unit: 'persona/any' },
];
